/**
 * Connexion — un seul geste, partagé par la monopage et la page d'invitation.
 *
 * Deux chemins coexistent tant que le lot 3 n'a pas retiré le cookie de session (D7,
 * revue qualité du lot 2) :
 *  - `startLogin(returnTo)` : mode CIAM (`ciamConfigured`), délègue à MSAL (`lib/auth.js`) —
 *    le choix de l'adresse, du code OTP et du fournisseur social se fait entièrement sur la
 *    page hébergée par le tenant Exidis (user flow `signin`).
 *  - `startLegacyLogin(provider, returnTo)` : repli historique, flux OAuth serveur par
 *    fournisseur (`/api/auth/:provider/start`) — utilisé tant que `VITE_CIAM_*` n'est pas
 *    posé côté build (production avant sa recette, `npm run dev:auth` sans config CIAM
 *    client). Disparaît au lot 3, avec le cookie de session qu'il alimente.
 */

import { API_BASE } from './api.js';
import { login } from './auth.js';

/** Priorité du fournisseur derrière le bouton unique, repli legacy uniquement : le tenant
 *  Exidis d'abord. */
export const ORDRE = ['microsoft', 'google', 'github'];

/** Le fournisseur que le bouton déclenche en repli legacy, ou `null` si aucun n'est exposé. */
export function fournisseurPrincipal(providers) {
  const actifs = new Set((providers || []).map((provider) => provider.name));
  return ORDRE.find((name) => actifs.has(name)) ?? null;
}

/**
 * Lance la connexion CIAM. `returnTo` est le chemin où l'utilisateur atterrit après
 * l'authentification — la liste des projets par défaut, ou la page qui l'a envoyé
 * (ex. `/invitation/:token`). Voyage dans le `state` MSAL, restitué par `initAuth()`.
 * @param {string} [returnTo]
 */
export function startLogin(returnTo = '/projets') {
  login(returnTo);
}

/**
 * Lance le flux OAuth serveur historique — repli hors configuration CIAM (D7). Navigation
 * plein écran, hors du contexte `fetch` : `window.location.assign` conserve l'historique
 * (contrairement à `.href =`), ce qui autorise un retour propre.
 * @param {string} provider
 * @param {string} [returnTo]
 */
export function startLegacyLogin(provider, returnTo = '/projets') {
  window.location.assign(
    `${API_BASE}/api/auth/${provider}/start?returnTo=${encodeURIComponent(returnTo)}`,
  );
}
